export default class Assets {

  static load(files, callback) {
    
    if (Array.isArray(files)) {
      Assets._files = Assets._files.concat(files)
    } else {
      Assets._files.push(files);
    }
    Assets._loadNext(callback);
  }

  static getSpritesheets() {
    let ret = new Array();
    for (let x = 0; x < Assets.assets.length; x++) {
      if (Assets.assets[x].type === Assets.TYPE_SHEET) {
        ret.push(Assets.assets[x]);
      }
    }
    return ret;
  }
  static getSounds() {
    let ret = new Array();
    for (let x = 0; x < Assets.assets.length; x++) {
      if (Assets.assets[x].type === Assets.TYPE_SOUND) {
        ret.push(Assets.assets[x]);
      }
    }
    return ret;
  }
  static getImages() {
    let ret = new Array();
    for (let x = 0; x < Assets.assets.length; x++) {
      
      if ((Assets.assets[x].type === Assets.TYPE_IMAGE) || (Assets.assets[x].type === Assets.TYPE_SHEET)) {
        ret.push(Assets.assets[x]);
      }
    }
    return ret;
  }

  static getAssetById(idAsset) {
    return Assets.assets.find(({ id }) => id === idAsset);
  }


  static _loadNext(callback) {
    if (Assets._current < Assets._files.length) {
      Assets._dispatch(callback, Assets.EVENT_LOAD_NEXT, { current: Assets._current, total: Assets._files.length });
      Assets._load(callback);
    } else {
      Assets._dispatch(callback, Assets.EVENT_ALL_LOADED, { current: Assets._current, total: Assets._files.length });
    }
  }

  static _load(callback) {
    let asset = JSON.parse(JSON.stringify(Assets._files[Assets._current]))
    if (Assets._isImage(asset.src)) {
      Assets._loadImage(asset, callback);
    } else {
      Assets._loadSound(asset, callback);
    }
  }

  static _isImage(file) {
    let images = "png,jpg,jpeg,gif"
    let ext = file.split("?")
    ext = ext[0].split(".")
    ext = ext[ext.length - 1].toLowerCase();
    if (images.indexOf(ext) >= 0) {
      return true;
    }
    return false;
  }


  static _loadImage(asset, callback) {
    let img = new Image();
    img.onload = Assets._imageLoaded.bind(Assets, asset, callback, img);
    img.onerror = Assets._imageLoaded.bind(Assets, asset, callback, img);
    img.src = asset.src;
  }

  static _imageLoaded(asset, callback, img, e) {
    let type = Assets.TYPE_IMAGE;
    if (asset.width) { // Sprite sheet
      type = Assets.TYPE_SHEET;
    }
    asset.file = asset.src
    asset.asset = img
    asset.type = type;
    Assets.assets.push(asset)
    Assets._dispatch(callback, Assets.EVENT_SINGLE_LOADED, { current: Assets._current, total: Assets._files.length });
    Assets._current++;
    Assets._loadNext(callback);
  }

  static _loadSound(asset, callback) {
    let audio = new Audio();
    audio.addEventListener("canplaythrough", Assets._soundLoaded.bind(Assets, asset, callback, audio), false);
    audio.addEventListener("error", Assets._soundLoaded.bind(Assets, asset, callback, audio), false);
    audio.src = asset.src;
    audio.load();
  }

  static _soundLoaded(asset, callback, audio, e) {
    asset.file = asset.src
    asset.asset = audio
    asset.type = Assets.TYPE_SOUND;
    Assets.assets.push(asset)
    Assets._dispatch(callback, Assets.EVENT_SINGLE_LOADED, { current: Assets._current, total: Assets._files.length });
    Assets._current++;
    Assets._loadNext(callback);
  }

  static _dispatch(callback, type, data = null) {
    if (callback) {
      callback.call(null, { type: type, data: data });
    }
  }
}

Assets._current = 0;
Assets._files = [];

Assets.EVENT_LOAD_NEXT = "eventLoadNext";
Assets.EVENT_ALL_LOADED = "eventAllLoaded";
Assets.EVENT_LOAD_ERROR = "eventLoadError";
Assets.EVENT_SINGLE_LOADED = "eventSingleLoaded";

Assets.assets = [];


Assets.TYPE_IMAGE = "img";
Assets.TYPE_SHEET = "sht";
Assets.TYPE_SOUND = "snd";